import styled from 'styled-components';

import { RecentBookingsIcon as RawRecentBookingsIcon } from 'assets/icons/RecentBookingsIcon';
import { BRAND_COLORS } from 'brand-guidelines/colors';
import { TYPOGRAPHY } from 'brand-guidelines/typography';

export const RecentBookingsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  /* For some reason styled-components is not styling the svg, so we need to use css selectors */
  & > svg {
    flex-shrink: 0;
  }
`;

export const RecentBookingsText = styled.p`
  display: inline-block;
  ${TYPOGRAPHY.OPEN_SANS.semiBold};
  font-size: 12px;
  line-height: 20px;
  color: ${({ $invertTextColor }) =>
    $invertTextColor ? BRAND_COLORS.white : BRAND_COLORS.darkGray};
`;

export const RecentBookingsIcon = styled(RawRecentBookingsIcon).attrs({
  color: BRAND_COLORS.red,
})``;
